<pre class="raw-data-ocr">
    <code>
        <span [innerHTML]="windowRef.config.context['data'].split('\n').join('<br>')">
        </span>
    </code>
</pre>